export enum NotificationType {
    CreditUnspentReminder = "credit-unspent-reminder",
    TradeInReminder = "trade-in-reminder",
}
